import { BrowserRouter, Route, Routes } from "react-router-dom";

/* Components */
import Background from "./components/Background.js";

/* Stranice */
import Pocetna from "./pages/Pocetna.js";
import KontaktPravnogLica from "./pages/KontaktPravnogLica.js";
import PromjenaPasswordaPravnogLica from "./pages/PromjenaPasswordaPravnogLica.js";
import PromjenaPasswordaFizickogLica from "./pages/PromjenaPasswordaFizickogLica.js";
import HvalaPasswordPromijenjen from "./pages/HvalaPasswordPromijenjen.js";
import HvalaPasswordPoslanNaMail from "./pages/HvalaPasswordPoslanNaMail.js";
import ZaboravljenPasswordPravnoLice from "./pages/ZaboravljenPasswordPravnoLice.js";
import ZaboravljenPasswordFizickoLice from "./pages/ZaboravljenPasswordFizickoLice.js";
import PrihvatanjePonude from "./pages/PrihvatanjePonude.js";
import PrihvatanjePonudeFizickogLica from "./pages/PrihvatanjePonudeFizickogLica.js";
import KontaktiranjePravnogLica from "./pages/KontaktiranjePravnogLica.js";
import DummyLogin from "./pages/dummy/DummyLogin.js";
import DummyLogout from "./pages/dummy/DummyLogout.js";
import RegistracijaPravnogLica from "./pages/RegistracijaPravnogLica.js";
import RegistracijaFizickogLica from "./pages/RegistracijaFizickogLica.js";
import LoginFizickogLica from "./pages/LoginFizickogLicaUspio.js";
import LoginPravnogLica from "./pages/LoginPravnogLicaUspio.js";

/* Modul */
import ProtectedRoute from "./modules/ProtectedRoute.js";

/*Error */
import Error from "./pages/error/Error.js";

function App() {
  return (
    <>
      <Background />
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Pocetna />} />
          <Route
            path="/registracija-pravnog-lica"
            element={<RegistracijaPravnogLica />}
          />
          <Route
            path="/registracija-fizickog-lica"
            element={<RegistracijaFizickogLica />}
          />
          <Route path="/login" element={<DummyLogin />} />
          <Route path="/logout" element={<DummyLogout />} />
          <Route
            path="/zaboravljen-password-pravno-lice"
            element={<ZaboravljenPasswordPravnoLice />}
          />
          <Route
            path="/zaboravljen-password-fizicko-lice"
            element={<ZaboravljenPasswordFizickoLice />}
          />
          <Route
            path="/hvala-password-poslan-na-mail"
            element={<HvalaPasswordPoslanNaMail />}
          />

          {/* ZASTICENE RUTE */}

          <Route
            path="/kontakt-pravnog-lica/:id"
            element={
              <ProtectedRoute userType="pravno">
                <KontaktPravnogLica />
              </ProtectedRoute>
            }
          />

          <Route
            path="/login-pravnog-lica"
            element={
              <ProtectedRoute userType="pravno">
                <LoginPravnogLica />
              </ProtectedRoute>
            }
          />
          <Route
            path="/login-fizickog-lica"
            element={
              <ProtectedRoute userType="fizicko">
                <LoginFizickogLica />
              </ProtectedRoute>
            }
          />
          <Route
            path="/promjena-passworda-pravnog-lica"
            element={
              <ProtectedRoute userType="pravno">
                <PromjenaPasswordaPravnogLica />
              </ProtectedRoute>
            }
          />
          <Route
            path="/promjena-passworda-fizickog-lica"
            element={
              <ProtectedRoute userType="fizicko">
                <PromjenaPasswordaFizickogLica />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hvala-password-promijenjen-pravno-lice"
            element={
              <ProtectedRoute userType="pravno">
                <HvalaPasswordPromijenjen />
              </ProtectedRoute>
            }
          />

          <Route
            path="/hvala-password-promijenjen-fizicko-lice"
            element={
              <ProtectedRoute userType="fizicko">
                <HvalaPasswordPromijenjen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kontaktiranje-pravnog-lica/:id"
            element={
              <ProtectedRoute userType="fizicko">
                <KontaktiranjePravnogLica />
              </ProtectedRoute>
            }
          />

          <Route
            path="/prihvatanje-ponude"
            element={
              <ProtectedRoute userType="pravno">
                <PrihvatanjePonude />
              </ProtectedRoute>
            }
          />

          <Route
            path="/prihvatanje-ponude-fizickog-lica/:id"
            element={
              <ProtectedRoute userType="fizicko">
                <PrihvatanjePonudeFizickogLica />
              </ProtectedRoute>
            }
          />
          {/* ERROR */}
          <Route
            path="/error/401"
            element={<Error code="401" message="Unauthorized." />}
          />
          <Route
            path="*"
            element={<Error code="404" message="Page not found." />}
          />
          <Route
            path="/error/:code"
            element={<Error code="404" message="Page not found." />}
          />

          {/* DUMMY RUTE */}

          <Route path="/dummy-login" element={<DummyLogin />} />
          <Route path="/dummy-logout" element={<DummyLogout />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
